import { ITokenSource } from "./ITokenSource";

/**
 * Abstract class that handles the token acquisition.
 */
export abstract class AbstractDataSource {
    protected readonly tokenSource: ITokenSource;

    constructor(tokenSource: ITokenSource) {
        this.tokenSource = tokenSource;
    }

    protected async getToken(scopes: string[]): Promise<string> {
        return await this.tokenSource.getToken(scopes);
    }
}